import { UserType } from '@enums';

export function sortByProperty(collection, property: string, sortOrder: string = 'desc') {
  
  let _sortOrder = 1;
  if (sortOrder === 'desc') {
    _sortOrder = -1;
  }
  if (property[0] === '-') {
    _sortOrder = -1;
    property = property.substr(1);
  }

  return collection.sort(function(a, b) {
    const result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * _sortOrder;
  });
}

export function contains(str, subStr) {
  return str.toString().includes(subStr.toString());
}

export function containsCaseInsensitive(str, subStr) {
  return str
    .toString()
    .toLowerCase()
    .includes(subStr.toString().toLowerCase());
}

export function getMonthText(date: Date) {
  switch (date.getUTCMonth() + 1) {
    case 1:
      return 'januari';
    case 2:
      return 'februari';
    case 3:
      return 'mars';
    case 4:
      return 'april';
    case 5:
      return 'maj';
    case 6:
      return 'juni';
    case 7:
      return 'juli';
    case 8:
      return 'augusti';
    case 9:
      return 'september';
    case 10:
      return 'oktober';
    case 11:
      return 'november';
    case 12:
      return 'december';
  }
}

// Workaround for known bug with nestled mat-tab-groups: https://github.com/angular/material2/issues/7274
export function fixInnerMatGroupTabs() {
  let event = document.createEvent('Event');
  event.initEvent('resize', false, true);
  // args: string type, boolean bubbles, boolean cancelable
  window.dispatchEvent(event);
}

export function getClientIdFromUserType(userType: UserType): string {
  switch (userType) {
    case UserType.Private:
      return 'sxapp.private';
    case UserType.Company:
      return 'sxapp.company';
    case UserType.Brf:
      return 'sxapp.brf';
    case UserType.Manager:
      return 'sxapp.manager';
  }
  return 'unknown';
}

export function arraysEqual(arr1, arr2): boolean {
  if ((!arr1 && !arr2) || (arr1 && arr1.length === 0 && !arr2) || (arr2 && arr2.length === 0 && !arr1)) {
    return true;
  }

  if ((arr1 && !arr2) || (!arr1 && arr2)) {
    return false;
  }
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = 0, len = arr1.length; i < len; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
}
